class CollectionSoldoutReorder {
  static requestId = 0;
  static cacheKey = '';
  static orderedItems = null;

  static init() {
    const grid = document.getElementById('product-grid');
    if (!grid || grid.dataset.soldoutJsReorder !== 'true') return;
    if (grid.dataset.soldoutReady === 'true') return;

    const sectionId = grid.dataset.id;
    const perPage = parseInt(grid.dataset.perPage, 10) || 16;
    const shopifyPages = parseInt(grid.dataset.shopifyPages, 10) || 1;
    const currentPage = CollectionSoldoutReorder.getCurrentPage();
    const requestId = ++CollectionSoldoutReorder.requestId;
    const cacheKey = `${window.location.pathname}?${CollectionSoldoutReorder.getFilterSortParams()}`;

    CollectionSoldoutReorder.reorder({
      grid,
      sectionId,
      perPage,
      shopifyPages,
      currentPage,
      requestId,
      cacheKey,
    });
  }

  static getCurrentPage() {
    const page = Number(new URLSearchParams(window.location.search).get('page') || '1');
    return Number.isFinite(page) && page > 0 ? page : 1;
  }

  static getFilterSortParams() {
    const params = new URLSearchParams(window.location.search);
    params.delete('page');
    params.delete('section_id');
    return params.toString();
  }

  static buildPageUrl(page, sectionId) {
    const params = new URLSearchParams(window.location.search);
    params.delete('section_id');
    if (page <= 1) params.delete('page');
    else params.set('page', String(page));
    params.set('section_id', sectionId);
    return `${window.location.pathname}?${params.toString()}`;
  }

  static async reorder({ grid, sectionId, perPage, shopifyPages, currentPage, requestId, cacheKey }) {
    try {
      let orderedItems = null;

      if (CollectionSoldoutReorder.cacheKey === cacheKey && CollectionSoldoutReorder.orderedItems) {
        orderedItems = CollectionSoldoutReorder.orderedItems;
      } else {
        const urls = [];
        for (let page = 1; page <= shopifyPages; page += 1) {
          urls.push(CollectionSoldoutReorder.buildPageUrl(page, sectionId));
        }

        const responses = await Promise.all(urls.map((url) => fetch(url).then((res) => res.text())));
        if (requestId !== CollectionSoldoutReorder.requestId) return;

        const available = [];
        const soldOut = [];
        const seen = new Set();

        responses.forEach((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const pageGrid = doc.getElementById('product-grid');
          if (!pageGrid) return;

          pageGrid.querySelectorAll(':scope > .grid__item').forEach((item) => {
            const id = item.dataset.productId || item.querySelector('[id*="Card"]')?.id || item.innerHTML.slice(0, 80);
            if (seen.has(id)) return;
            seen.add(id);

            const isAvailable = item.dataset.available !== 'false';
            const clone = item.cloneNode(true);
            if (isAvailable) available.push(clone);
            else soldOut.push(clone);
          });
        });

        orderedItems = available.concat(soldOut);
        CollectionSoldoutReorder.cacheKey = cacheKey;
        CollectionSoldoutReorder.orderedItems = orderedItems;
      }

      if (requestId !== CollectionSoldoutReorder.requestId) return;

      const start = (currentPage - 1) * perPage;
      const pageItems = orderedItems.slice(start, start + perPage);

      grid.innerHTML = '';
      pageItems.forEach((item, index) => {
        item.classList.remove('scroll-trigger', 'animate--slide-in', 'scroll-trigger--offscreen');
        item.style.removeProperty('--animation-order');
        if (index < 2) {
          item.querySelectorAll('img[loading="lazy"]').forEach((img) => img.removeAttribute('loading'));
        }
        grid.appendChild(item);
      });

      grid.dataset.soldoutReady = 'true';
      grid.classList.add('product-grid--soldout-ready');
    } catch (error) {
      console.error('Collection sold out reorder failed', error);
      grid.dataset.soldoutReady = 'true';
      grid.classList.add('product-grid--soldout-ready');
    }
  }
}

document.addEventListener('DOMContentLoaded', () => CollectionSoldoutReorder.init());

if (typeof FacetFiltersForm !== 'undefined') {
  const originalRender = FacetFiltersForm.renderProductGridContainer;
  FacetFiltersForm.renderProductGridContainer = function (html) {
    CollectionSoldoutReorder.orderedItems = null;
    CollectionSoldoutReorder.cacheKey = '';
    originalRender.call(this, html);
    CollectionSoldoutReorder.init();
  };
} else {
  document.addEventListener('DOMContentLoaded', () => {
    if (typeof FacetFiltersForm === 'undefined') return;
    const originalRender = FacetFiltersForm.renderProductGridContainer;
    FacetFiltersForm.renderProductGridContainer = function (html) {
      CollectionSoldoutReorder.orderedItems = null;
      CollectionSoldoutReorder.cacheKey = '';
      originalRender.call(this, html);
      CollectionSoldoutReorder.init();
    };
  });
}
